<template>
  <div>
    <div class="card">
      <div class="card-image waves-effect waves-block waves-light">
        <img class="activator" src="../assets/robot.png">
      </div>
      <div class="card-content">
        <span class="card-title activator grey-text text-darken-4">Smart Assistant<i class="material-icons right">more_vert</i></span>
        <p><a href="#">How can I help you?</a></p>
      </div>
      <div class="card-reveal">
        <span class="card-title grey-text text-darken-4">Smart bot<i class="material-icons right">close</i></span>
        <p>Our intelligent bot is available round the clock for your service. This featuer is under the constraction. </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:"RightNav",
  data(){
    return {

    };
  }
}
</script>
<style scoped>
.card{
  box-shadow: none;
}
</style>


